












import RankingElementsList from './ranking-elements-list.component.vue';

export default {
  name: 'products-ranking',
  props: {
    products: {
      type: Object,
      required: true
    },
    messages: {
      type: Object,
      required: true
    }
  },
  components: {
    RankingElementsList
  }
};

